module.exports = __webpack_public_path__ + "img/qd-img-6.bd65dc7d.jpg";